const options = {
  fastClickMsg: '数据请求中，请稍后重试'
}

export default class RemoveRepeatAjax {
  constructor (msg = options.fastClickMsg) {
    this.pendingAjax = []
    this.fastClickMsg = msg
  }

  removePendingAjax (url, type) {
    const i = this.pendingAjax.findIndex(item => item.url === url)

    if (i > -1) {
      type === 'req' && this.pendingAjax[i].c(this.fastClickMsg)

      this.pendingAjax.splice(i, 1)
    }
  }

  pushPendingAjax (req) {
    this.pendingAjax.push(req)
  }
}
